var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCrossIcon = function SvgCrossIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.575 4.434a.881.881 0 0 0-1.248 0L10 8.752 5.673 4.426a.881.881 0 1 0-1.247 1.247L8.753 10l-4.327 4.327a.881.881 0 1 0 1.247 1.248L10 11.248l4.327 4.327a.881.881 0 1 0 1.248-1.248L11.248 10l4.327-4.327a.887.887 0 0 0 0-1.239Z",
    fill: "#8F8F9B"
  })));
};
export default SvgCrossIcon;